import { z } from "zod";
import { truncateTypes } from "../../../statistics";

export const getInvoiceStatisticsSchema = z
	.object({
		startDate: z.string(),
		endDate: z.string(),
		type: z.enum(["user", "client", "project"]),
		truncateType: z.enum(truncateTypes),
		clientId: z.string().optional(),
		projectId: z.string().optional(),
	})
	.superRefine((data, ctx) => {
		if (data.type === "client" && !data.clientId) {
			ctx.addIssue({
				code: "custom",
				message: "clientId is required when type is 'client'",
				path: ["clientId"],
			});
		} else if (data.type === "project" && !data.projectId) {
			ctx.addIssue({
				code: "custom",
				message: "projectId is required when type is 'project'",
				path: ["projectId"],
			});
		}
	});

export type GetInvoiceStatisticsQuerySchema = z.infer<typeof getInvoiceStatisticsSchema>;
